import api from "./api";
import { generateErrorMessage } from "../utils/message";

/*Login Activities*/
export const fetchLoginActivitiesFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, sort = {}) => {
  try {
    // Build params object with column-specific filters
    const params = {
      page,
      per_page: perPage
    };

    // Add search parameter if provided (for backward compatibility)
    if (search) {
      params.search = search;
    }

    // Add column-specific parameters
    if (columnFilters.username) params.username = columnFilters.username;
    if (columnFilters.message) params.message = columnFilters.message;
    if (columnFilters.ip_address) params.ip_address = columnFilters.ip_address;
    if (columnFilters.operating_system) params.operating_system = columnFilters.operating_system;
    if (columnFilters.browser) params.browser = columnFilters.browser;

    if (sort && sort.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === 'desc' ? 'desc' : 'asc';
    }

    const response = await api.get("/authentications/login-activity", {
      params: params,
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "login activity");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* Fetch every login-activity row matching the filters (for Export). */
export const fetchAllLoginActivitiesForExport = async ({ search = "", columnFilters = {}, sort = {} } = {}, onProgress) => {
  const PER_PAGE = 1000;
  const collected = [];
  let page = 1;
  let total = 0;
  for (;;) {
    const response = await fetchLoginActivitiesFromAPI(page, PER_PAGE, search, columnFilters, sort);
    const payload = response?.activities || {};
    const rows = Array.isArray(payload.data) ? payload.data : [];
    collected.push(...rows);
    total = Number(payload.pagination?.total) || collected.length;
    if (onProgress) onProgress(collected.length, total);
    const lastPage = Number(payload.pagination?.total_pages) || 1;
    if (rows.length === 0 || page >= lastPage || collected.length >= total) break;
    page += 1;
  }
  return collected;
};

